import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNews, moveCalendar } from "../../../../store/actions";
import NewsCalendar from "./NewsCalendar";
import NewsContent from "./NewsContent";
import { NewsData } from "../../../../lib/types";
import { NEWS_DETAIL } from "../../../../lib/enums";
import NewsGame from "./NewsGame";
import { DragescentState } from "../../../../store/reducers/stateType";
import InnerLoader from "../../../Common/InnerLoader";

const News = () => {
  const race = useSelector((state: DragescentState) => state.governorate.race);
  const alliance = useSelector((state: DragescentState) => state.governorate.alliance);
  const gameDay = useSelector((state: DragescentState) => state.governorate.gameDay);
  const news = useSelector((state: DragescentState) => state.governorate.news);

  const [activeType, setActiveType] = useState(alliance ? "alliance" : "game");
  const [activeDay, setActiveDay] = useState(gameDay.gameDay);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNews(gameDay.gameDay, activeType));
  }, [])

  const handleTypeChange = (newType: string) => {
    setActiveType(newType);
    dispatch(getNews(gameDay.gameDay, newType));
  }

  const changeActiveDay = (day: number) => {
    if (day === activeDay) {
      return;
    }

    dispatch(getNews(day, activeType));
    setActiveDay(day);
  }

  console.log(news);

  return (
    <>
      <section className="boxes-group">
        <h2 className="h2 h2-first">
          <span className="bordered">Setting of list</span></h2>
        <hr className="divider"/>
        <div className="box">
          <div className="text-center buttons">
            <a
              className={`btn btn-blank btn-no-width ${!alliance ? "disabled" : (activeType === "alliance"
                ? " selected" : "")}`}
              onClick={() => handleTypeChange("alliance")}
            >Alliance</a>
            <a
              className={`btn btn-blank btn-no-width ${activeType === "game" ? "selected" : ""}`}
              onClick={() => handleTypeChange("game")}
            >Game</a>
          </div>
        </div>
        <span className="divider"/>
        <div className="box">
          <h2 className="h2 h2-first">
            {activeType === "alliance" ? "Alliance" : "Game"} news {activeType === "alliance"
            && <em>{alliance.name}</em>}
          </h2>
        </div>
        <span className="divider"/>
        {news && <div className="box">
          <div className="row" id="calendar">
            <NewsCalendar
              day={gameDay.gameDay}
              activeDay={activeDay || gameDay.gameDay}
              month={parseInt(news.activeMonth, 10)}
              year={parseInt(news.activeYear, 10)}
              firstMonth={news.activeMonth === parseInt(news.firstMonth, 10)}
              lastMonth={news.activeMonth === parseInt(news.lastMonth, 10)}
              newsMonth={news.newsMonth}
              changeDay={changeActiveDay}
              moveCalendar={
                direction => dispatch(moveCalendar(
                  activeType,
                  news.activeYear,
                  news.activeMonth,
                  direction
                ))
              }
            />
          </div>
          <p>
            Explanatory colors:
            <span className="white">War news</span>,
            <span className="table-calendar">Count without news</span>
          </p>
        </div>}
        <span className="divider"/>
      </section>

      {news && news.news ? (activeType === "game"
        ? <NewsGame gameNews={news.news} />
        : <NewsContent
          news={news.news}
          coalition={alliance}
          // battleground={news.news[1]
          // && !!news.news[1].length && ["left", "center", "right", "backup"]
          //   .reduce((
          //     b: { [key: string]: { news: NewsData | null; turns: string[] | null; } },
          //     position
          //   ) => {
          //     const positionNews = news.news[1]
          //       .find((n: NewsData) => n.details[NEWS_DETAIL.BattlegroundPosition]
          //         && n.details[NEWS_DETAIL.BattlegroundPosition].value === position);
          //     return {
          //       ...b,
          //       [position]: {
          //         news: positionNews,
          //         turns: positionNews && positionNews.details[NEWS_DETAIL.MeleeTurnsDetails]
          //           && positionNews.details[NEWS_DETAIL.MeleeTurnsDetails].value.split("|")
          //       }
          //     }
          //   }, {})}
          battleground={news.news[1] && !!news.news[1].length && ["left", "center", "right", "backup"]
            .reduce((
              b: { [key: string]: NewsData[] },
              position
            ) => {
              const positionNews: NewsData[] = news.news[1]
                .filter((n: NewsData) => n.details[NEWS_DETAIL.BattlegroundPosition]
                  && n.details[NEWS_DETAIL.BattlegroundPosition].value === position);
              return {
                ...b,
                [position]: positionNews.sort(
                  (n1, n2) => parseInt(n1.details[NEWS_DETAIL.BattleRound].value, 10)
                    - parseInt(n2.details[NEWS_DETAIL.BattleRound].value, 10)
                )
              }
            }, {})}
        />) : news ? <div className='boxes-group'>
        <span className={"divider"} />
        <div className="box news-item text-center text-info">No news for chosen day</div>
        <span className={"divider"} />
      </div> : <InnerLoader race={race.name} />}
    </>
  )
}

export default News;
